import { render, staticRenderFns } from "./BranchesCreate.vue?vue&type=template&id=066d2fd8&"
import script from "./BranchesCreate.vue?vue&type=script&lang=js&"
export * from "./BranchesCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports